import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './Stakeholder_Profile_S.css';

const Stakeholder_Profile_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Stakeholder Profile');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/STAKEHOLDER_PROFILE/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/Stakeholder_Profile', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/STAKEHOLDER_PROFILE/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/Stakeholder_Profile',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/Stakeholder_Profile',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/Stakeholder_Profile_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/Stakeholder_Profile',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/Stakeholder_Profile_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/Stakeholder_Profile_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/Stakeholder_Profile_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/Stakeholder_Profile',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/Stakeholder_Profile',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/Stakeholder_Profile',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/Stakeholder_Profile',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/Stakeholder_Profile',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [STAKEHOLDER_PROFILE, setSTAKEHOLDER_PROFILE] = React.useState(null);
  const [STAKEHOLDER_PROFILE_S, setSTAKEHOLDER_PROFILE_S] = React.useState(null);

  var Ids = [];
  for(var Ele in STAKEHOLDER_PROFILE_S){
	  for(var Sec in STAKEHOLDER_PROFILE_S[Ele]){
			if(Sec == "id")
				Ids.push(STAKEHOLDER_PROFILE_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(STAKEHOLDER_PROFILE_S[Ele]["status"]);
			else if(Array.isArray(STAKEHOLDER_PROFILE_S[Ele][Sec]))
				  for(var Row in STAKEHOLDER_PROFILE_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in STAKEHOLDER_PROFILE_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/STAKEHOLDER_PROFILE`).then((response) => {
      setSTAKEHOLDER_PROFILE(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setSTAKEHOLDER_PROFILE_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!STAKEHOLDER_PROFILE_S) return <div>Loading...</div>;

 const handleLastDataSTAKEHOLDER_PROFILE_S = async (data) => {
  };




  const handleAddSTAKEHOLDER_PROFILE_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/STAKEHOLDER_PROFILE_S', JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/STAKEHOLDER_PROFILE_S');
      setSTAKEHOLDER_PROFILE_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE_S));
	Temp_Data["1"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_0"]=value;
	//handleAddSTAKEHOLDER_PROFILE_S(Temp_Data,App_Data['STAKEHOLDER_PROFILE_S']);
	Form_Data_onChange("1","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_0",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE_S(Temp_Data);
    setSTAKEHOLDER_PROFILE_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE_S));
	Temp_Data["1"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_1"]=value;
	//handleAddSTAKEHOLDER_PROFILE_S(Temp_Data,App_Data['STAKEHOLDER_PROFILE_S']);
	Form_Data_onChange("1","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_1",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE_S(Temp_Data);
    setSTAKEHOLDER_PROFILE_S(Temp_Data);
 }; 
  

const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE));
	Temp_Data["1"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_2"]=value;
	Form_Data_onChange("1","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_2",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE(Temp_Data);
    setSTAKEHOLDER_PROFILE(Temp_Data);
	//handleAddSTAKEHOLDER_PROFILE(Temp_Data,App_Data['STAKEHOLDER_PROFILE']);
  }; 
  

    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE_S));
	Temp_Data["1"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_3"]=value;
	//handleAddSTAKEHOLDER_PROFILE_S(Temp_Data,App_Data['STAKEHOLDER_PROFILE_S']);
	Form_Data_onChange("1","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_3",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE_S(Temp_Data);
    setSTAKEHOLDER_PROFILE_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE_S));
	Temp_Data["1"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_4"]=value;
	//handleAddSTAKEHOLDER_PROFILE_S(Temp_Data,App_Data['STAKEHOLDER_PROFILE_S']);
	Form_Data_onChange("1","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_4",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE_S(Temp_Data);
    setSTAKEHOLDER_PROFILE_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE_S));
	Temp_Data["1"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_5"]=value;
	//handleAddSTAKEHOLDER_PROFILE_S(Temp_Data,App_Data['STAKEHOLDER_PROFILE_S']);
	Form_Data_onChange("1","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_5",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE_S(Temp_Data);
    setSTAKEHOLDER_PROFILE_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_6_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_6"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE_S));
	Temp_Data["1"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_6"]=value;
	//handleAddSTAKEHOLDER_PROFILE_S(Temp_Data,App_Data['STAKEHOLDER_PROFILE_S']);
	Form_Data_onChange("1","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_6",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE_S(Temp_Data);
    setSTAKEHOLDER_PROFILE_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE_S));
	Temp_Data["2"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_0"]=value;
	//handleAddSTAKEHOLDER_PROFILE_S(Temp_Data,App_Data['STAKEHOLDER_PROFILE_S']);
	Form_Data_onChange("2","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_0",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE_S(Temp_Data);
    setSTAKEHOLDER_PROFILE_S(Temp_Data);
 }; 
  

const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE));
	Temp_Data["2"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_1"]=value;
	Form_Data_onChange("2","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_1",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE(Temp_Data);
    setSTAKEHOLDER_PROFILE(Temp_Data);
	//handleAddSTAKEHOLDER_PROFILE(Temp_Data,App_Data['STAKEHOLDER_PROFILE']);
  }; 
  

    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE_S));
	Temp_Data["2"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_2"]=value;
	Form_Data_onChange("2","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_2",value,Temp_Data);
    setSTAKEHOLDER_PROFILE_S(Temp_Data);
  }; 
  

const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE));
	Temp_Data["2"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_3"]=value;
	Form_Data_onChange("2","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_3",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE(Temp_Data);
    setSTAKEHOLDER_PROFILE(Temp_Data);
	//handleAddSTAKEHOLDER_PROFILE(Temp_Data,App_Data['STAKEHOLDER_PROFILE']);
  }; 
  


const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE));
	Temp_Data["3"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_0"]=value;
	Form_Data_onChange("3","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_0",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE(Temp_Data);
    setSTAKEHOLDER_PROFILE(Temp_Data);
	//handleAddSTAKEHOLDER_PROFILE(Temp_Data,App_Data['STAKEHOLDER_PROFILE']);
  }; 
  


const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE));
	Temp_Data["3"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_1"]=value;
	Form_Data_onChange("3","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_1",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE(Temp_Data);
    setSTAKEHOLDER_PROFILE(Temp_Data);
	//handleAddSTAKEHOLDER_PROFILE(Temp_Data,App_Data['STAKEHOLDER_PROFILE']);
  }; 
  

  
      
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE_S));
	Temp_Data["3"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_2"]=value ? true : false; // optionally just use boolean
	//handleAddSTAKEHOLDER_PROFILE_S(Temp_Data,App_Data['STAKEHOLDER_PROFILE_S']);
	Form_Data_onChange("3","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_2",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE_S(Temp_Data);
    setSTAKEHOLDER_PROFILE_S(Temp_Data);
 }; 
  


  
      
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE_S));
	Temp_Data["4"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_0"]=value ? true : false; // optionally just use boolean
	//handleAddSTAKEHOLDER_PROFILE_S(Temp_Data,App_Data['STAKEHOLDER_PROFILE_S']);
	Form_Data_onChange("4","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_0",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE_S(Temp_Data);
    setSTAKEHOLDER_PROFILE_S(Temp_Data);
 }; 
  


    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE_S));
	Temp_Data["4"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_1"]=value;
	//handleAddSTAKEHOLDER_PROFILE_S(Temp_Data,App_Data['STAKEHOLDER_PROFILE_S']);
	Form_Data_onChange("4","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_1",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE_S(Temp_Data);
    setSTAKEHOLDER_PROFILE_S(Temp_Data);
 }; 
  

const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE));
	Temp_Data["9"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_0",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE(Temp_Data);
    setSTAKEHOLDER_PROFILE(Temp_Data);
	//handleAddSTAKEHOLDER_PROFILE(Temp_Data,App_Data['STAKEHOLDER_PROFILE']);
  }; 
  

    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE_S));
	Temp_Data["9"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_1"]=value;
	//handleAddSTAKEHOLDER_PROFILE_S(Temp_Data,App_Data['STAKEHOLDER_PROFILE_S']);
	Form_Data_onChange("9","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_1",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE_S(Temp_Data);
    setSTAKEHOLDER_PROFILE_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE_S));
	Temp_Data["9"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_2"]=value;
	//handleAddSTAKEHOLDER_PROFILE_S(Temp_Data,App_Data['STAKEHOLDER_PROFILE_S']);
	Form_Data_onChange("9","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_2",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE_S(Temp_Data);
    setSTAKEHOLDER_PROFILE_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE_S));
	Temp_Data["9"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_3"]=value;
	//handleAddSTAKEHOLDER_PROFILE_S(Temp_Data,App_Data['STAKEHOLDER_PROFILE_S']);
	Form_Data_onChange("9","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_3",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE_S(Temp_Data);
    setSTAKEHOLDER_PROFILE_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(STAKEHOLDER_PROFILE_S));
	Temp_Data["9"]["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_4"]=value;
	//handleAddSTAKEHOLDER_PROFILE_S(Temp_Data,App_Data['STAKEHOLDER_PROFILE_S']);
	Form_Data_onChange("9","PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_4",value,Temp_Data);
 	//handleLastDataSTAKEHOLDER_PROFILE_S(Temp_Data);
    setSTAKEHOLDER_PROFILE_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = STAKEHOLDER_PROFILE_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Stakeholder Profile')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Stakeholder ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_0" type="text" className="form-control" placeholder="Stakeholder ID"  
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Stakeholder ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Organization ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_1" type="text" className="form-control" placeholder="Organization ID"  
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Organization ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Stakeholder Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_2"   onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_2_Change} className="form-control" name="Stakeholder Type"  >
						  <option value="Project Owner">Project Owner</option>
						  <option value="Developer">Developer</option>
						  <option value="Property Manager">Property Manager</option>
						  <option value="Inspector">Inspector</option>
						  <option value="Appraiser">Appraiser</option>
						  <option value="Title Company">Title Company</option>
						  <option value="Escrow Agent">Escrow Agent</option>
						  <option value="Broker-Dealer">Broker-Dealer</option>
						  <option value="Transfer Agent">Transfer Agent</option>
						  <option value="Legal Counsel">Legal Counsel</option>
						  <option value="Insurance / Bond Provider">Insurance / Bond Provider</option>
						  <option value="Contractor">Contractor</option>
						  <option value="Architect / Engineer">Architect / Engineer</option>
						  <option value="Auditor">Auditor</option>
						  <option value="Fund Administrator">Fund Administrator</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Stakeholder Type
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '180ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Legal Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_3" type="text" className="form-control" placeholder="Legal Name"  
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '180ch' }}>
						 {t(`Enter Legal Name`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '120ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Contact Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_4" type="text" className="form-control" placeholder="Contact Name"  
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '120ch' }}>
						 {t(`Enter Contact Name`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '160ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Contact Email`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_5" type="text" className="form-control" placeholder="Contact Email"  
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_5_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '160ch' }}>
						 {t(`Enter Contact Email`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Contact Phone`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_6" type="text" className="form-control" placeholder="Contact Phone"  
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_6_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_6"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Contact Phone`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '80ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`License Number`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_0" type="text" className="form-control" placeholder="License Number"  
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '80ch' }}>
						 {t(`Enter License Number`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`License State`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_1"   onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_1_Change} className="form-control" name="License State"  >
						  <option value="AL">AL</option>
						  <option value="AK">AK</option>
						  <option value="AZ">AZ</option>
						  <option value="AR">AR</option>
						  <option value="CA">CA</option>
						  <option value="CO">CO</option>
						  <option value="CT">CT</option>
						  <option value="DE">DE</option>
						  <option value="FL">FL</option>
						  <option value="GA">GA</option>
						  <option value="HI">HI</option>
						  <option value="ID">ID</option>
						  <option value="IL">IL</option>
						  <option value="IN">IN</option>
						  <option value="IA">IA</option>
						  <option value="KS">KS</option>
						  <option value="KY">KY</option>
						  <option value="LA">LA</option>
						  <option value="ME">ME</option>
						  <option value="MD">MD</option>
						  <option value="MA">MA</option>
						  <option value="MI">MI</option>
						  <option value="MN">MN</option>
						  <option value="MS">MS</option>
						  <option value="MO">MO</option>
						  <option value="MT">MT</option>
						  <option value="NE">NE</option>
						  <option value="NV">NV</option>
						  <option value="NH">NH</option>
						  <option value="NJ">NJ</option>
						  <option value="NM">NM</option>
						  <option value="NY">NY</option>
						  <option value="NC">NC</option>
						  <option value="ND">ND</option>
						  <option value="OH">OH</option>
						  <option value="OK">OK</option>
						  <option value="OR">OR</option>
						  <option value="PA">PA</option>
						  <option value="RI">RI</option>
						  <option value="SC">SC</option>
						  <option value="SD">SD</option>
						  <option value="TN">TN</option>
						  <option value="TX">TX</option>
						  <option value="UT">UT</option>
						  <option value="VT">VT</option>
						  <option value="VA">VA</option>
						  <option value="WA">WA</option>
						  <option value="WV">WV</option>
						  <option value="WI">WI</option>
						  <option value="WY">WY</option>
						  <option value="DC">DC</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter License State
				     </div>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`License Expiry Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_2" type="date"   
							onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_2_Change} style={{ borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_2"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter License Expiry Date
					  </div>
				  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Professional Insurance Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_3"   onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_3_Change} className="form-control" name="Professional Insurance Status"  >
						  <option value="Not Required">Not Required</option>
						  <option value="Pending">Pending</option>
						  <option value="Active">Active</option>
						  <option value="Expired">Expired</option>
						  <option value="Insufficient">Insufficient</option>
						  <option value="Waived">Waived</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Professional Insurance Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`KYC KYB Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_0"   onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_0_Change} className="form-control" name="KYC KYB Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Pending">Pending</option>
						  <option value="Passed">Passed</option>
						  <option value="Failed">Failed</option>
						  <option value="Manual Review">Manual Review</option>
						  <option value="Expired">Expired</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter KYC KYB Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Background Check Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_1"   onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_1_Change} className="form-control" name="Background Check Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Pending">Pending</option>
						  <option value="Passed">Passed</option>
						  <option value="Failed">Failed</option>
						  <option value="Manual Review">Manual Review</option>
						  <option value="Waived">Waived</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Background Check Status
				     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Conflict Of Interest Flag`)} <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_2_Change} 
					  checked={STAKEHOLDER_PROFILE_S?.["3"]?.["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_2"] === "true" || STAKEHOLDER_PROFILE_S?.["3"]?.["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_2"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Approved For Platform`)} <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_0_Change} 
					  checked={STAKEHOLDER_PROFILE_S?.["4"]?.["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_0"] === "true" || STAKEHOLDER_PROFILE_S?.["4"]?.["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '2000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_1" type="text" className="form-control" placeholder="Approval Notes"  
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '2000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_0"   onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Stakeholder ID`)}</th>
                        <th>{t(`Organization ID`)}</th>
                        <th>{t(`Stakeholder Type`)}</th>
                        <th>{t(`Legal Name`)}</th>
                        <th>{t(`Contact Name`)}</th>
                        <th>{t(`Contact Email`)}</th>
                        <th>{t(`Contact Phone`)}</th>
                        <th>{t(`License Number`)}</th>
                        <th>{t(`License State`)}</th>
                        <th>{t(`License Expiry Date`)}</th>
                        <th>{t(`Professional Insurance Status`)}</th>
                        <th>{t(`KYC KYB Status`)}</th>
                        <th>{t(`Background Check Status`)}</th>
                        <th>{t(`Conflict Of Interest Flag`)}</th>
                        <th>{t(`Approved For Platform`)}</th>
                        <th>{t(`Approval Notes`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {STAKEHOLDER_PROFILE_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_0"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_1"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_2"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_3"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_4"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_5"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_1_6"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_0"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_1"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_2"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_2_3"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_0"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_1"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_3_2"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_0"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_4_1"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_0"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_1"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_2"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_3"]} </td>
						<td>{e["PLATFORM_CORE_02_ORGANIZATION_STAKEHOLDER_ONBOARDING_STAKEHOLDER_PROFILE_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default Stakeholder_Profile_S;  